// extracted by css-extract-rspack-plugin
module.exports =  {"root":"ConversationView__root___gNC2M"};